/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Text,
  View,
  TouchableOpacity,
  ActivityIndicator,
} from 'react-native';
import { Button } from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { SectionGrid } from 'react-native-super-grid';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import AORTypes from '../../types';
import { AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
import { translate } from '../../locales/i18n';
import styles from '../../styles';
import QueryMyLeases from '../../q/QueryMyLeases';
import AppBadge from '../../components/apps/AppBadge';

const today = new Date();
const milliseconds = today.getUTCMilliseconds();
const seconds = milliseconds / 1000;

class MyApps extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'MyApps';
  }

  render() {
    const {
      history,
      loading,
      appsNotUsed,
      appsUsed,
      appsExpired,
      user,
      direction,
    } = this.props;

    if (!user) {
      return (
        <>
        </>
      );
    }

    if (loading) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    if (!loading
      && appsNotUsed.length === 0
      && appsUsed.length === 0
      && appsExpired.length === 0) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
          }}
        >
          <Text>{translate('my_apps_none')}</Text>
          <View>
            <Button
              title={translate('menu_find_apps')}
              containerStyle={{
                marginTop: 40,
                alignSelf: 'center',
              }}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={() => {
                history.push('/ai-agents');
              }}
            />
          </View>
        </View>
      );
    }

    const containerStyle = direction === 'row' ? {
      alignSelf: 'flex-end',
      paddingTop: 8,
      paddingRight: 12,
    } : ifIphoneX({
      alignSelf: 'center',
      paddingTop: 38,
    }, {
      alignSelf: 'flex-end',
      paddingTop: 8,
      paddingRight: 12,
    });

    return (
      <View style={styles.view.headed}>
        <Button
          title={translate('menu_find_apps')}
          containerStyle={containerStyle}
          buttonStyle={styles.button.primary}
          disabledStyle={styles.button.primaryDisabled}
          titleStyle={styles.button.primaryTitle}
          disabledTitleStyle={styles.button.primaryTitleDisabled}
          onPress={() => {
            history.push('/ai-agents');
          }}
        />

        <SectionGrid
          // TODO(clairbee): make the price line non-wrapping and, then, reduce 'itemDimension'
          itemDimension={310} // The lower value makes Safari wrap the price if both rent and buy are two digits prior to the decimal point
          sections={[
            ...(appsNotUsed.length > 0
              ? [{
                title: translate('my_apps_not_used'),
                data: appsNotUsed,
              }]
              : []
            ),
            ...(appsUsed.length > 0
              ? [{
                title: translate('my_apps_used'),
                data: appsUsed,
              }]
              : []
            ),
            ...(appsExpired.length > 0
              ? [{
                title: translate('my_apps_expired'),
                data: appsExpired,
              }]
              : []
            ),
          ]}
          renderItem={
            ({ item }) => (item.app ? (
              <TouchableOpacity onPress={() => (
                history.push(`/ai-agent/${item.app.uuid}`)
              )}
              >
                <AppBadge data={JSON.parse(item.app.data)} />
              </TouchableOpacity>
            ) : (
              <Text>
                Error displaying app.
              </Text>
            ))
          }
          renderSectionHeader={
            ({ section }) => (
              <Text style={styles.myApps.section}>
                {section.title}
              </Text>
            )
          }
        />
      </View>
    );
  }
}

MyApps.defaultProps = {
  user: null,
};

MyApps.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  direction: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  loading: PropTypes.bool.isRequired,
  appsNotUsed: PropTypes.arrayOf(AORTypes.MyLease).isRequired,
  appsUsed: PropTypes.arrayOf(AORTypes.MyLease).isRequired,
  appsExpired: PropTypes.arrayOf(AORTypes.MyLease).isRequired,
};

export default compose(
  graphql(QueryMyLeases, {
    props: (props) => {
      console.log('graphql returned: QueryMyLeases: ');
      console.log(props.data);
      return {
        loading: props.data.loading,
        appsNotUsed:
          props.data.queryMyLeases && props.data.queryMyLeases.items
            ? props.data.queryMyLeases.items.filter((item) => (!(item.expires && item.expires > seconds) && item.accessed === undefined)).sort((a, b) => (a.created > b.created))
            : [],
        appsUsed:
          props.data.queryMyLeases && props.data.queryMyLeases.items
            ? props.data.queryMyLeases.items.filter((item) => (!(item.expires && item.expires > seconds) && item.accessed !== undefined)).sort((a, b) => (a.created > b.created))
            : [],
        appsExpired:
          props.data.queryMyLeases && props.data.queryMyLeases.items
            ? props.data.queryMyLeases.items.filter((item) => (item.expires && item.expires < seconds)).sort((a, b) => (a.created > b.created))
            : [],
      };
    },
    options: (props) => ({
      client: AppSyncClientAuthenticated(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAuthenticated(),
  })
)(MyApps);
